const LaundryIcon = () => (
  <svg
    width="22"
    height="25"
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 24H21.0423V1H1V6.37385V24Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M21.0423 6.06018H1" stroke="#31493C" strokeMiterlimit="10" />
    <path
      d="M11.6301 19.6578C14.4397 19.6578 16.7173 17.3802 16.7173 14.5706C16.7173 11.7611 14.4397 9.48346 11.6301 9.48346C8.82056 9.48346 6.54297 11.7611 6.54297 14.5706C6.54297 17.3802 8.82056 19.6578 11.6301 19.6578Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
    <path d="M14.3301 1V3.11965" stroke="#31493C" strokeMiterlimit="10" />
    <path d="M16.7168 1V3.11965" stroke="#31493C" strokeMiterlimit="10" />
    <path
      d="M11.6297 18.2316C13.6516 18.2316 15.2907 16.5926 15.2907 14.5707C15.2907 12.5487 13.6516 10.9097 11.6297 10.9097C9.60783 10.9097 7.96875 12.5487 7.96875 14.5707C7.96875 16.5926 9.60783 18.2316 11.6297 18.2316Z"
      stroke="#31493C"
      strokeMiterlimit="10"
    />
  </svg>
);

export default LaundryIcon;
